import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from './modules/user';
import features from './modules/features';
import playlist from './modules/playlist';
import presearch from './modules/presearch';
import player from './modules/player';
import discover from './modules/discover';
import episodes from './modules/episodes';
import library from './modules/library';
import subscription from './modules/subscription';
import globals from './modules/globals';
import events from './modules/events';
import pricing from './modules/pricing';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage,
  reducer: state => ({
    user: state.user,
    playlist: {
      playlistType: state.playlist.playlistType,
    },
    library: state.library,
    features: state.features,
    events: state.events,
  }),
});

export default new Vuex.Store({
  modules: {
    user,
    features,
    playlist,
    presearch,
    player,
    discover,
    episodes,
    subscription,
    library,
    globals,
    events,
    pricing,
  },
  plugins: [vuexLocalStorage.plugin],
});
